import React from 'react';
import './StaticPage.css';

export default function PrivacyPolicy() {
  return (
    <div className="static-page">
      <nav className="static-nav">
        <a href="/" className="logo-text">
          <span style={{color:'#0D9488'}}>ICH</span>TYP<span className="logo-de">.DE</span>
        </a>
      </nav>

      <main className="static-main privacy-main">
        <div className="privacy-card">
          <h1 className="privacy-title">Datenschutzerklärung</h1>
          <p className="privacy-date">Stand: April 2025</p>

          <div className="privacy-toc">
            <p style={{fontWeight:800,marginBottom:8}}>Inhalt</p>
            {['Verantwortlicher','Welche Daten wir erheben','Zweck der Datenverarbeitung',
              'Cookies & Tracking','E-Mail-Kommunikation','Deine Rechte',
              'Datensicherheit','Kontakt'].map((t,i) => (
              <a key={i} href={`#s${i+1}`} className="toc-link">{i+1}. {t}</a>
            ))}
          </div>

          <section id="s1" className="privacy-section">
            <h2>1. Verantwortlicher</h2>
            <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
            <div className="privacy-box">
              <strong>ICHTYP.DE</strong><br/>
              E-Mail: kontakt@ichtyp.de<br/>
              Website: https://ichtyp.de
            </div>
          </section>

          <section id="s2" className="privacy-section">
            <h2>2. Welche Daten wir erheben</h2>
            <p>Wir erheben folgende Kategorien personenbezogener Daten:</p>

            <h3>2.1 Automatisch erhobene Daten</h3>
            <p>Beim Besuch unserer Website werden automatisch folgende technische Daten erhoben:</p>
            <ul>
              <li>IP-Adresse (anonymisiert nach 24 Stunden)</li>
              <li>Browsertyp und -version</li>
              <li>Betriebssystem</li>
              <li>Datum und Uhrzeit des Zugriffs</li>
              <li>Referrer-URL (Seite, von der du zu uns kamst)</li>
            </ul>

            <h3>2.2 Von dir bereitgestellte Daten</h3>
            <p>Wenn du den Persönlichkeitstest abschließt und deine E-Mail angibst, speichern wir:</p>
            <ul>
              <li>E-Mail-Adresse</li>
              <li>Testergebnis (MBTI-Typ, z.B. INTJ)</li>
              <li>Zeitpunkt der Testdurchführung</li>
              <li>Kampagnen-ID (cid) — falls du über eine E-Mail-Kampagne zu uns kamst</li>
              <li>Abonnenten-ID (uid) — anonyme ID aus unserem E-Mail-System</li>
              <li>Cookie-Einwilligungsstatus und -zeitpunkt</li>
              <li>Opt-in-Zeitpunkt und -methode</li>
            </ul>

            <h3>2.3 Cookie-Daten</h3>
            <p>Details zu Cookies findest du in Abschnitt 4.</p>
          </section>

          <section id="s3" className="privacy-section">
            <h2>3. Zweck der Datenverarbeitung</h2>
            <div className="privacy-table-wrap">
              <table className="privacy-table">
                <thead>
                  <tr><th>Zweck</th><th>Rechtsgrundlage</th><th>Speicherdauer</th></tr>
                </thead>
                <tbody>
                  <tr><td>Bereitstellung des Persönlichkeitstests</td><td>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</td><td>Dauer der Sitzung</td></tr>
                  <tr><td>Versand des Ergebnisberichts per E-Mail</td><td>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</td><td>Bis zur Abmeldung</td></tr>
                  <tr><td>Statistische Auswertung (anonymisiert)</td><td>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)</td><td>12 Monate</td></tr>
                  <tr><td>Kampagnenmessung</td><td>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</td><td>Bis zur Abmeldung</td></tr>
                  <tr><td>Abmeldung / Opt-out-Verwaltung</td><td>Art. 6 Abs. 1 lit. c DSGVO (rechtliche Verpflichtung)</td><td>3 Jahre</td></tr>
                </tbody>
              </table>
            </div>
          </section>

          <section id="s4" className="privacy-section">
            <h2>4. Cookies &amp; Tracking</h2>
            <p>Wir verwenden folgende Arten von Cookies:</p>

            <h3>Notwendige Cookies</h3>
            <p>Diese Cookies sind für den Betrieb der Website unbedingt erforderlich und können nicht deaktiviert werden. Sie speichern keine personenbezogenen Daten dauerhaft.</p>
            <ul>
              <li><strong>session</strong> — Sitzungsverwaltung während des Tests (SessionStorage, wird beim Schließen des Browsers gelöscht)</li>
              <li><strong>cookie_consent</strong> — Speichert deine Cookie-Einwilligungsentscheidung (LocalStorage, 12 Monate)</li>
            </ul>

            <h3>Analyse-Cookies (nur mit Einwilligung)</h3>
            <p>Diese Cookies helfen uns zu verstehen, wie Besucher unsere Website nutzen. Alle Daten sind anonymisiert.</p>
            <ul>
              <li>Seitenaufrufe und Testabschlussraten (keine personenbezogenen Daten)</li>
            </ul>

            <h3>Marketing-Cookies (nur mit Einwilligung)</h3>
            <ul>
              <li><strong>cid / uid</strong> — Kampagnenverfolgung aus E-Mail-Kampagnen (SessionStorage)</li>
            </ul>

            <p>Du kannst deine Einwilligung jederzeit widerrufen, indem du die Browser-Daten löschst oder uns kontaktierst.</p>
          </section>

          <section id="s5" className="privacy-section">
            <h2>5. E-Mail-Kommunikation</h2>
            <p>Wenn du deine E-Mail-Adresse angibst, um deinen Persönlichkeitsbericht zu erhalten, erklärst du dich damit einverstanden, dass wir dir:</p>
            <ul>
              <li>Deinen Persönlichkeitsbericht zusenden</li>
              <li>Gelegentlich relevante Inhalte zu Persönlichkeitsentwicklung und verwandten Themen senden</li>
            </ul>
            <p>Du kannst dich jederzeit von unseren E-Mails abmelden:</p>
            <ul>
              <li>Über den Abmeldelink am Ende jeder E-Mail</li>
              <li>Direkt unter <a href="/abbestellen" style={{color:'var(--teal)'}}>ichtyp.de/abbestellen</a></li>
              <li>Per E-Mail an kontakt@ichtyp.de</li>
            </ul>
            <p>Nach der Abmeldung wird deine E-Mail-Adresse in unsere Abmeldeliste aufgenommen, um sicherzustellen, dass du keine weiteren E-Mails erhältst.</p>
          </section>

          <section id="s6" className="privacy-section">
            <h2>6. Deine Rechte</h2>
            <p>Du hast nach der DSGVO folgende Rechte:</p>
            <div className="rights-grid">
              {[
                ['📋','Auskunft','Recht auf Auskunft über die von uns gespeicherten Daten (Art. 15 DSGVO)'],
                ['✏️','Berichtigung','Recht auf Korrektur unrichtiger Daten (Art. 16 DSGVO)'],
                ['🗑️','Löschung','Recht auf Löschung deiner Daten ("Recht auf Vergessenwerden", Art. 17 DSGVO)'],
                ['⏸️','Einschränkung','Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)'],
                ['📤','Übertragbarkeit','Recht auf Datenübertragbarkeit (Art. 20 DSGVO)'],
                ['🚫','Widerspruch','Widerspruchsrecht gegen die Verarbeitung (Art. 21 DSGVO)'],
              ].map(([icon,title,desc]) => (
                <div key={title} className="right-card">
                  <span className="right-icon">{icon}</span>
                  <strong>{title}</strong>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
            <p style={{marginTop:20}}>
              Zur Ausübung deiner Rechte wende dich an: <a href="mailto:kontakt@ichtyp.de" style={{color:'var(--teal)'}}>kontakt@ichtyp.de</a>
            </p>
            <p>Du hast außerdem das Recht, Beschwerde bei der zuständigen Datenschutzbehörde einzureichen. In Deutschland ist dies der jeweilige Landesdatenschutzbeauftragte.</p>
          </section>

          <section id="s7" className="privacy-section">
            <h2>7. Datensicherheit</h2>
            <p>Wir treffen geeignete technische und organisatorische Maßnahmen zum Schutz deiner Daten:</p>
            <ul>
              <li>SSL/TLS-Verschlüsselung der gesamten Datenübertragung (HTTPS)</li>
              <li>Passwortgeschützter Datenbankzugang</li>
              <li>Regelmäßige Sicherheitsupdates</li>
              <li>Beschränkter Zugang zu personenbezogenen Daten</li>
              <li>Automatische IP-Anonymisierung nach 24 Stunden</li>
            </ul>
          </section>

          <section id="s8" className="privacy-section">
            <h2>8. Kontakt</h2>
            <p>Bei Fragen zum Datenschutz oder zur Ausübung deiner Rechte:</p>
            <div className="privacy-box">
              E-Mail: <a href="mailto:kontakt@ichtyp.de" style={{color:'var(--teal)'}}>kontakt@ichtyp.de</a><br/>
              Website: <a href="https://ichtyp.de" style={{color:'var(--teal)'}}>ichtyp.de</a>
            </div>
            <p style={{marginTop:16,color:'var(--text3)',fontSize:14}}>
              Wir bemühen uns, Anfragen innerhalb von 30 Tagen zu beantworten.
            </p>
          </section>

        </div>
      </main>

      <footer className="static-footer">
        <p>© 2025 ICHTYP.DE · <a href="/datenschutz">Datenschutz</a> · <a href="/abbestellen">Abmelden</a></p>
      </footer>
    </div>
  );
}
